import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import InHouseOffersListView from "./InHouseOffersListView";
const InHouseOffersPage = () => {
    var _a, _b, _c;
    const navigate = useNavigate();
    const location = useLocation();
    const [params] = useSearchParams();
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const eventId = (_a = params.get("event_id")) !== null && _a !== void 0 ? _a : undefined;
    const reservationTime = (_b = params.get("reservation_time")) !== null && _b !== void 0 ? _b : undefined;
    const mode = params.get("mode") === "cart" ? "cart" : "view";
    const returnTo = params.get("return_to");
    const initialSelected = Array.isArray((_c = location.state) === null || _c === void 0 ? void 0 : _c.selectedCodes)
        ? (location.state.selectedCodes)
        : [];
    const handleBack = () => {
        if (returnTo) {
            navigate(returnTo, {
                replace: true,
                state: { selectedCouponCodes: initialSelected },
            });
        }
        else {
            navigate(-1);
        }
    };
    const handleConfirm = (selectedOffers) => {
        const selectedCouponCodes = selectedOffers.map((o) => o.code);
        if (returnTo) {
            navigate(returnTo, {
                replace: true,
                state: { selectedCouponCodes },
            });
        }
        else {
            navigate(-1);
        }
    };
    return (_jsxs(Box, { w: "100%", minH: "100vh", bg: "#100D09", color: "white", children: [_jsxs(Flex, { align: "center", gap: 3, px: 4, py: 4, children: [_jsx(IconButton, { "aria-label": "Go back", icon: _jsx(ChevronLeftIcon, { boxSize: 6 }), onClick: handleBack, bg: "#16171C", border: "1px solid #2A2A2A", color: "white", borderRadius: "10", size: "md", _hover: { bg: "#1F2025" } }), _jsx(Text, { fontSize: "md", fontWeight: 600, children: "In-House Offers" })] }), _jsx(InHouseOffersListView, { eventId: eventId, reservationTime: reservationTime, mode: mode, initialSelectedCodes: initialSelected, onConfirm: handleConfirm })] }));
};
export default InHouseOffersPage;
